function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpPrimaryBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.8 4.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-up-primary-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Recurring-Gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.32,4.68a.24.24,0,0,0,0-.36L4.68.68a.24.24,0,0,0-.36,0L.68,4.32a.24.24,0,0,0,0,.36l.39.39a.24.24,0,0,0,.36,0L4.5,2,7.57,5.07a.24.24,0,0,0,.36,0Z",
    transform: "translate(-0.6 -0.6)",
    style: {
      fill: "#2774ae"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpPrimaryBlue);
export default __webpack_public_path__ + "static/media/arrow-up-primary-blue.c22e0259713862b6a781f9aa46f97c4e.svg";
export { ForwardRef as ReactComponent };